import { Component, EventEmitter, Output, Input } from '@angular/core';
import { TableColumn } from '../../../../../shared/models/components/tables/table.models';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'app-modal-create-scenario',
    imports: [CommonModule, FormsModule, DialogModule, SelectModule],
    templateUrl: './modal-create-scenario.component.html',
    styleUrl: './modal-create-scenario.component.scss'
})

export class ModalCreateScenarioComponent {
  @Output() close = new EventEmitter<void>();
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() baseScenarioChange = new EventEmitter<TableColumn | null>();
  @Output() addColumn = new EventEmitter<{newColumnName: string; baseScenario: TableColumn | null}>();

  @Input() isVisible = false;
  @Input() columns: TableColumn[] = [];

  selectedBaseScenario: TableColumn | null = null;
  newColumnName = '';

  @Input() set baseScenario(value: TableColumn | null) {
    this.selectedBaseScenario = value;
  }

  onVisibleChange(isVisible: boolean) {
    this.isVisible = isVisible;
    this.isVisibleChange.emit(isVisible);
  }

  onBaseScenarioChange(baseScenario: TableColumn | null) {
    this.selectedBaseScenario = baseScenario;
    this.baseScenarioChange.emit(baseScenario);
  }

  onCloseModal() {
    this.newColumnName = ""; 
    this.onVisibleChange(false);
    this.close.emit();
  }

  onAddColumn(){
    this.addColumn.emit({
      newColumnName: this.newColumnName,
      baseScenario: this.selectedBaseScenario
    });
    this.onCloseModal();
  }

  isAddButtonDisabled(){
    return this.newColumnName.length===0;
  }
 
}
